export default __webpack_public_path__ + "static/media/liquidTubeTrailer.31df32dd.svg";